module.exports = __webpack_public_path__ + "static/media/default_image.e8a66f19.webp";